<div class="ag-label-panel">
    <label>{{label}}</label>
</div>
